import { createContext, useContext, useState } from 'react';

const SidebarContext = createContext();

export const SidebarProvider = ({ children, initialActive = 'Dashboard' }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [openMenus, setOpenMenus] = useState({});
  const [activeItem, setActiveItem] = useState(initialActive);

  /**
   * Accordion-style toggle:
   * - Top-level: only one root menu open at a time.
   * - Nested: only one submenu per parent open at a time.
   */
  const toggleMenu = (text, parent = null) => {
    setOpenMenus((prev) => {
      const newOpenMenus = { ...prev };

      if (!parent) {
        // Top-level menu
        // Close all other top-level menus (keys without '/')
        Object.keys(newOpenMenus).forEach((key) => {
          if (!key.includes('/')) newOpenMenus[key] = false;
        });
        newOpenMenus[text] = !prev[text];
      } else {
        // Nested menu
        // Close siblings under the same parent
        Object.keys(newOpenMenus).forEach((key) => {
          if (key.startsWith(parent + '/')) newOpenMenus[key] = false;
        });
        const key = `${parent}/${text}`;
        newOpenMenus[key] = !prev[key];
      }

      return newOpenMenus;
    });
  };

  return (
    <SidebarContext.Provider
      value={{ isCollapsed, setIsCollapsed, openMenus, toggleMenu, activeItem, setActiveItem }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
